import './General.css';
import img from '../../../resources/tasty-salad-with-pasta-with-tasty-shrimpsavocado 1.png'
function General() {
    return (
        <div className='general_main_div'>
            <div className='all_margin'>
                <div className='margin_auto_width'>
                    <div className='general_text_div'>
                        <h1 className='text_align_center'>Empowering Your <span className='green_gradient_p_animated'>Wellness </span>
                            with a Passion for
                            <span className='green_gradient_p_animated'> Health </span> and <span className='green_gradient_p_animated'>Dedication </span>
                            to Transforming Lives.</h1>

                        <p className='text_align_center gray_scale_6 font_size_20'>Our mission is to empower your wellness journey by combining a deep passion for health with innovative solutions. We are dedicated to helping you achieve your goals, whether it's through macro tracking, expert nutritional guidance, or tools that make healthy living accessible and enjoyable. Join us as we transform lives, one healthy habit at a time.</p>
                    </div>
                </div>
            </div>

            <div className='width_100'>
                <img src={img} className='general_image' />
                <div className='general_image_blur_overlay' />
            </div>
        </div>
    );
}

export default General;
